/* import __COLOCATED_TEMPLATE__ from './posting-create.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-posting-create';

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: '',
  CLASS_NAME,

  /**
   * Register services
   */
  state: service('states/routes/posting-create'),
  stateManager: service('state-managers/routes/posting-create'),

  /**
   * @inheritDoc
   */
  didInsertElement() {
    this._boundOnBeforeUnlnoad = this._handleOnBeforeUnload.bind(this);
    window.addEventListener('beforeunload', this._boundOnBeforeUnlnoad);
  },

  /**
   * Handle if the user is trying to leave the page.
   *
   * @return {string}
   */
  _handleOnBeforeUnload() {
    if (!this.get('state.isConfirmDiscardData') || !this.get('state.isAnyInfoSuppliedInCreationForm')) {
      // don't show the unload prompt if we have disabled it OR if we don't have any data entered.
      return;
    }

    let isEditing = this.get('state.editingPosting'),
      areAnyEditsMade = this.get('state.isExistingPostingUpdated');

    if (isEditing) {
      if (areAnyEditsMade) {
        //in most cases we don't have control of what the browser says, so it will hopefully prompt that they need
        //take care of something.
        return 'Are you sure you want to leave?  Your changes will be lost.';
      } else {
        // in case where user clicked edit, but didn't make any changes, don't do anything.
        return undefined;
      }
    }

    return 'Are you sure you want to leave?  Your changes will be lost.';
  },
});
